import { createModel } from '@/store/tools';

const model = {
    namespace: 'enterpriserecharge',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getPayTypeList': T('getPayTypeList'),
            'getRechargeSourceList': T('getRechargeSourceList'),
            'getRechargeList': T('getRechargeList'),
            'getDetail': T('getDetail'),
        },
        actions: {
            'getPayTypeList': A('getPayTypeList'),
            'getRechargeSourceList': A('getRechargeSourceList'),
            'getRechargeList': A('getRechargeList'),
            'getDetail': A('getDetail'),
        },
        sagas: {
            'getPayTypeList': S('getPayTypeList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getRechargeSourceList': S('getRechargeSourceList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getRechargeList': S('getRechargeList', '/?cmd=com.xqxc.api.pig.mis.pay.RechargeRecordMisService.rechargeRecordPage'),
            'getDetail': S('getDetail', '/?cmd=com.xqxc.api.pig.mis.pay.WithdrawalMisService.getPaymentApplication'),
        },
        reducers: {
            'payTypeList': R('getPayTypeList', []),
            'rechargeSourceList': R('getRechargeSourceList', []),
            'rechargeList': R('getRechargeList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'detail': R('getDetail', { auditLogs: [] }),
        }
    })
};
export default createModel(model);